import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function WhatToBuild() {
  return <section id="servicios" className="bg-arena py-[56px] md:py-[88px]" data-id="element-288" data-mp="34drxtjya71wd">
      <div className="max-w-[1240px] mx-auto px-6 md:px-16" data-id="element-289" data-mp="38ebs8frgzret">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-16 max-w-[560px]" data-id="element-290" data-mp="38cqxoq55o8gy">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-291" data-mp="3n1n2mebx15dc">
            ¿QUÉ QUIERES MEJORAR?
          </span>
          <h2 className="font-display text-[30px] md:text-[42px] font-medium text-carbon leading-[1.15]" data-id="element-292" data-mp="3w4fw8o8klt6c">
            Construimos lo que tu empresa necesita.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 border-t border-b border-carbon/10" data-id="element-293" data-mp="21pd9uzetir7n">
          {/* Presencia Digital */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col p-8 md:p-9 border-b md:border-b-0 md:border-r border-carbon/10 bg-arena" data-id="element-294" data-mp="2eyxsjj4zwnnz">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-4" data-id="element-295" data-mp="2xx0ko6sub0q0">
              PRESENCIA DIGITAL
            </span>
            <h3 className="font-display text-[19px] font-medium text-carbon mb-2.5 leading-[1.25]" data-id="element-296" data-mp="2svb9mr5man1x">
              Haz que tu empresa se vea y funcione mejor en digital.
            </h3>
            <p className="font-body text-[13.5px] text-carbon/60 leading-[1.65] mb-6 flex-grow" data-id="element-297" data-mp="2iyosodgewg56">
              Webs, experiencias digitales, UX, conversión, formularios,
              WhatsApp, analítica e integraciones.
            </p>
            <a href="#precios" className="mt-auto inline-flex items-center gap-1.5 font-display font-medium text-[14px] text-verde hover:gap-2.5 transition-all duration-200" data-id="element-298" data-mp="3vq079b9q0mjs">
              Ver presencia digital <ArrowRight size={14} data-id="element-299" data-mp="3lqr9067tolrm" />
            </a>
          </motion.div>

          {/* Automatización */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.06
        }} className="flex flex-col p-8 md:p-9 border-b md:border-b-0 md:border-r border-carbon/10 bg-arena" data-id="element-300" data-mp="3qplx9nok72j4">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-4" data-id="element-301" data-mp="3805vyy51v61n">
              AUTOMATIZACIÓN
            </span>
            <h3 className="font-display text-[19px] font-medium text-carbon mb-2.5 leading-[1.25]" data-id="element-302" data-mp="2t3x108s6zev1">
              Haz que tus procesos trabajen sin depender de tareas
              manuales.
            </h3>
            <p className="font-body text-[13.5px] text-carbon/60 leading-[1.65] mb-6 flex-grow" data-id="element-303" data-mp="2egpviilh793j">
              IA, WhatsApp, CRM, agenda, seguimiento e integraciones.
            </p>
            <a href="#precios" className="mt-auto inline-flex items-center gap-1.5 font-display font-medium text-[14px] text-verde hover:gap-2.5 transition-all duration-200" data-id="element-304" data-mp="2og72r4gdlv1m">
              Ver automatización <ArrowRight size={14} data-id="element-305" data-mp="2tdp1k20oitvw" />
            </a>
          </motion.div>

          {/* Presencia Digital Completa */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.12
        }} className="relative flex flex-col p-8 md:p-9 bg-carbon text-arena" data-id="element-306" data-mp="375n4tw7plvk5">
            <span className="absolute top-0 left-0 w-full h-[2px] bg-verde" data-id="element-307" data-mp="3c5hu5vbu6d33" />
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-4" data-id="element-308" data-mp="19ib6f2wcxdes">
              ORIGEN / COMPLETO
            </span>
            <h3 className="font-display text-[19px] font-medium text-arena mb-2.5 leading-[1.25]" data-id="element-309" data-mp="1eejfbyjyoadi">
              Presencia + automatización. Un solo proyecto.
            </h3>
            <p className="font-body text-[13.5px] text-arena/65 leading-[1.65] mb-6 flex-grow" data-id="element-310" data-mp="1o5waaz123gnr">
              Construimos tu presencia digital y conectamos lo que sucede
              después de cada oportunidad.
            </p>
            <a href="#precios" className="mt-auto inline-flex items-center gap-1.5 font-display font-medium text-[14px] text-arena hover:gap-2.5 transition-all duration-200" data-id="element-311" data-mp="vjl85jxsx7ou">
              Ver presencia completa <ArrowRight size={14} data-id="element-312" data-mp="2bwt877w0odg0" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}